import { Box, Paper } from "@mui/material";
import { SawNextProduct } from "../models/types";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	EMPTY,
	InfoGrid,
	InlineStats,
	NEXT_ACCENT,
	NEXT_ACCENT_DARK,
	PartPairRows,
	SawChip,
} from "./primitives";

type Props = {
	data?: SawNextProduct | null;
};

export const NextProductCard = ({ data = null }: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle
			title="Next Product to Run"
			action={
				<SawChip
					label={`Work Order ${data?.workOrder ?? EMPTY}`}
					accent={NEXT_ACCENT}
					accentDark={NEXT_ACCENT_DARK}
				/>
			}
		/>

		<Box sx={CardBodySx}>
			<PartPairRows
				accent={NEXT_ACCENT}
				part={data?.partNumber}
				ext={data?.extendedPartNumber ?? null}
			/>

			<InlineStats
				items={[
					{ label: "Section", value: data?.section },
					{ label: "Grade", value: data?.grade },
					{ label: "Pieces", value: data?.pieces },
				]}
			/>

			<InfoGrid
				items={[
					{ label: "Bundle Length", value: data?.bundleLength ?? null },
					{ label: "Bundles to Load", value: data?.bundlesToLoad ?? null },
					// Material to stage for the next run — the product's own pair,
					// until the tablet scans real staged tags ahead of changeover.
					{ label: "Load Part #", value: data?.partNumber ?? null, span: true },
					{
						label: "Load Ext Part #",
						value: data?.extendedPartNumber ?? null,
						span: true,
					},
				]}
			/>
		</Box>
	</Paper>
);
